import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskCircle } from '../product-ui-task-circle/product-ui-task-circle';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function BoardsViewScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-four" appWindowSize="lg" data-sentry-element="ProductUISceneContainer" data-sentry-component="BoardsViewScene" data-sentry-source-file="boards-view.tsx">
            <ProductUISceneLayer position="bottom" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="boards-view.tsx">
                <ProductUIAppWindow showSidebar={false} sidebar={<TemplateSidebarStandard />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="board">
                                <ProductUIView.Header title={t('sequence.boardsView.title')} showSidebarToggle={true} />
                                <ProductUIView.BoardView>
                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.boardsView.backlog')}
                                        </ProductUIView.SectionTitle>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} variant="board" attributeSection={<ProductUITask.AttributeContainer>
                                                    <ProductUITask.Attribute variant="subtask" count={2} completedCount={0} />
                                                </ProductUITask.AttributeContainer>}>
                                            <ProductUITask.Text>
                                                {t('sequence.boardsView.revamp')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                    </ProductUIView.Section>
                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.boardsView.inProgress')}
                                        </ProductUIView.SectionTitle>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} variant="board">
                                            <ProductUITask.Text>
                                                {t('sequence.boardsView.team')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} variant="board">
                                            <ProductUITask.Text>
                                                {t('sequence.boardsView.calendarView')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                    </ProductUIView.Section>

                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.boardsView.readyForQA')}
                                        </ProductUIView.SectionTitle>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} variant="board">
                                            <ProductUITask.Text>
                                                {t('sequence.boardsView.shortcuts')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} variant="board">
                                            <ProductUITask.Text>
                                                {t('sequence.boardsView.persistentCompleted')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} variant="board">
                                            <ProductUITask.Text>
                                                {t('sequence.boardsView.dragAndDrop')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                    </ProductUIView.Section>
                                </ProductUIView.BoardView>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="boards-view.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { BoardsViewScene };